<button mat-icon-button (click)="helpClick()">
    <mat-icon [style.color]="getIconBackgroundColor()">help</mat-icon>
</button>